import { render, staticRenderFns } from "./contactBlock.vue?vue&type=template&id=2f3ffb63&"
import script from "./contactBlock.vue?vue&type=script&lang=js&"
export * from "./contactBlock.vue?vue&type=script&lang=js&"
import style0 from "./contactBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports